export default "__VITE_ASSET__CuIVFpBL__"